"use strict";
const moment = require('moment');
const FORMAT_HIDDEN_INPUT = 'hhmm';
const FORMAT_INPUT = 'HH[h] : mm[m]';
const FORMAT_HOURS_MINUTES = 'h[h] m[m]';
const FORMAT_HOURS_MINUTES_SECONDS = 'h[h] m[m] s[s]';
function timeTracked(ms) {
    return moment.duration(ms).format(FORMAT_HOURS_MINUTES_SECONDS);
}
exports.timeTracked = timeTracked;
function timeRemaining(ms) {
    if (ms >= 60 * 60 * 1000) {
        return moment.duration(ms).format(FORMAT_HOURS_MINUTES);
    }
    else if (ms >= 1000) {
        if (ms % (60 * 1000) === 0) {
            return moment.duration(ms).format(FORMAT_HOURS_MINUTES);
        }
        else {
            return moment.duration(ms).format(FORMAT_HOURS_MINUTES_SECONDS);
        }
    }
    else {
        return '1s';
    }
}
exports.timeRemaining = timeRemaining;
function timeHiddenInput(ms) {
    return moment.duration(ms).format(FORMAT_HIDDEN_INPUT);
}
exports.timeHiddenInput = timeHiddenInput;



/** WEBPACK FOOTER **
 ** ./src/utils/format.ts
 **/